import * as R from 'remeda';
import {
  getGridSingleSelectOperators,
  GridFilterInputValueProps,
  GridFilterItem,
} from '@rossum/ui/x-data-grid-pro';
import { MultiSelectInput } from './MultiSelectInput';

const defaultOperator = 'isAnyOf';

export const queuesOperators = R.partition(
  getGridSingleSelectOperators(),
  operator => operator.value === defaultOperator
)
  .flat()
  .filter(operator => {
    return ![
      'equals',
      'is',
      'endsWith',
      'isEmpty',
      'isNotEmpty',
      'startsWith',
      'contains',
    ].includes(operator.value);
  })
  .map(operator => ({
    ...operator,
    getApplyFilterFn: (filterItem: GridFilterItem) => {
      if (!filterItem.field || !filterItem.value || !filterItem.operator) {
        return null;
      }

      return (values: Array<{ id: string }>): boolean => {
        const value = Array.isArray(values)
          ? values.map(v => String(v.id))
          : null;

        if (!value) {
          return true;
        }

        if (filterItem.operator === 'isAnyOf') {
          return value.some(el => filterItem.value.includes(el));
        }

        if (filterItem.operator === 'not') {
          return !value.some(el => filterItem.value.includes(el));
        }
        return false;
      };
    },

    InputComponent: (props: GridFilterInputValueProps) =>
      MultiSelectInput(props),
  }));
